import { render, staticRenderFns } from "./trouble-verify.vue?vue&type=template&id=4612d1c2"
import script from "./trouble-verify.vue?vue&type=script&lang=js"
export * from "./trouble-verify.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports